import { getAuthCookie } from './auth-session.util';

/** Paths that receive `?workspaceId=` on the landing page (`attachWorkspaceParams`). */
export const WORKSPACE_SCOPED_API_PATHS = ['/v1/customer/home'];

function resolveStoredValue(raw: string | null): string | null {
  if (!raw) {
    return null;
  }
  const trimmed = raw.trim();
  if (!trimmed) {
    return null;
  }
  if (
    (trimmed.startsWith('"') && trimmed.endsWith('"')) ||
    trimmed.startsWith('{')
  ) {
    try {
      const parsed = JSON.parse(trimmed) as unknown;
      if (typeof parsed === 'string' && parsed.trim()) {
        return parsed.trim();
      }
    } catch {
      // fall through to raw value
    }
  }
  return trimmed;
}

/** Workspace id from session storage (same sources as the auth interceptor header). */
export function resolveStoredWorkspaceId(): string | undefined {
  const raw =
    (typeof localStorage !== 'undefined' ? localStorage.getItem('workspace_id') : null) ||
    getAuthCookie('workspace_id');
  const value = resolveStoredValue(raw);
  return value ?? undefined;
}

export function isWorkspaceScopedApiPath(url: string): boolean {
  return WORKSPACE_SCOPED_API_PATHS.some((path) => url.includes(path));
}
